import { handleActions } from "redux-actions";

import {
	getPresetItemsListAsyncAction,
	getPresetItemDetailAsyncAction,
	postPresetItemAsyncAction,
	updatePresetItemAsyncAction,
	getPresetDetailAsyncAction,
	resetAction,
} from "./presetsActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	item_list: defaultAjaxState,
	preset_detail: defaultAjaxState,
	preset_item_detail: defaultAjaxState,
	post_preset_item: defaultAjaxState,
	update_preset_item: defaultAjaxState,
};

export const presetsReducer = handleActions(
	new Map([
		// get preset detail
		[
			getPresetDetailAsyncAction.request,
			(state, { payload }) => ({
				...state,
				preset_detail: {
					...initialState.preset_detail,
					loading: true,
				},
			}),
		],
		[
			getPresetDetailAsyncAction.success,
			(state, { payload }) => ({
				...state,
				preset_detail: {
					...initialState.preset_detail,
					response: payload,
				},
			}),
		],
		[
			getPresetDetailAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				preset_detail: {
					...initialState.preset_detail,
					error: payload,
				},
			}),
		],

		// get preset item list
		[
			getPresetItemsListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				item_list: {
					...initialState.item_list,
					loading: true,
				},
			}),
		],
		[
			getPresetItemsListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				item_list: {
					...initialState.item_list,
					response: payload,
				},
			}),
		],
		[
			getPresetItemsListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				item_list: {
					...initialState.item_list,
					error: payload,
				},
			}),
		],

		// get preset item detail
		[
			getPresetItemDetailAsyncAction.request,
			(state, { payload }) => ({
				...state,
				preset_item_detail: {
					...initialState.preset_item_detail,
					loading: true,
				},
			}),
		],
		[
			getPresetItemDetailAsyncAction.success,
			(state, { payload }) => ({
				...state,
				preset_item_detail: {
					...initialState.preset_item_detail,
					response: payload,
				},
			}),
		],
		[
			getPresetItemDetailAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				preset_item_detail: {
					...initialState.preset_item_detail,
					error: payload,
				},
			}),
		],

		// post preset item
		[
			postPresetItemAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_preset_item: {
					...initialState.post_preset_item,
					loading: true,
				},
			}),
		],
		[
			postPresetItemAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_preset_item: {
					...initialState.post_preset_item,
					response: payload,
				},
			}),
		],
		[
			postPresetItemAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_preset_item: {
					...initialState.post_preset_item,
					error: payload,
				},
			}),
		],

		// update preset item
		[
			updatePresetItemAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_preset_item: {
					...initialState.update_preset_item,
					loading: true,
				},
			}),
		],
		[
			updatePresetItemAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_preset_item: {
					...initialState.update_preset_item,
					response: payload,
				},
			}),
		],
		[
			updatePresetItemAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_preset_item: {
					...initialState.update_preset_item,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
